import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {PageViewModel} from '@components/ui/table-template/models/page-view-model';
import {EntityAccountViewModel} from '../view-models/entity-account.view-model';

import {EntityAccountCardComponent} from '../entity-account-card/entity-account-card.component';

@Component({
    selector: 'app-entity-account-card-container',
    templateUrl: './entity-account-card-container.component.html',
    styleUrls: ['./entity-account-card-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EntityAccountCardComponent]
})
export class EntityAccountCardContainerComponent {

  public readonly currentPage = input.required<PageViewModel<EntityAccountViewModel>>();

  public readonly cardClicked = output<EntityAccountViewModel>();

  handleCardClicked(entityAccountVM: EntityAccountViewModel): void {
    this.cardClicked.emit(entityAccountVM);
  }
}
